import script from "./CustomUploadInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomUploadInput.vue?vue&type=script&setup=true&lang=ts"

import "./CustomUploadInput.vue?vue&type=style&index=0&id=065b7db4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065b7db4"]])

export default __exports__